var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69.32 71.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#257df9;}.cls-2,.cls-3,.cls-4{stroke-width:2px;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#7da2fe;}.cls-4,.cls-7,.cls-6{fill:none;}.cls-8{clip-path:url(#clippath);}.cls-5{fill:url(#linear-gradient);stroke-width:.78px;}.cls-6{stroke-width:1.21px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.72,28.83c-3.64-3.49-12-4.77-16.95-1.2,0,0-5.49-16.26-6.09-17.02S36.95,0,36.95,0l12.15,8.72-3.37,20.11Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 53.68,
    y1: 32.16,
    x2: 59.68,
    y2: 32.16,
    gradientTransform: "translate(-39.25 8.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.22,34.36c1.91,4.05,11.27-.35,9.97-4.09s-10.26,.11,.12,6.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.01,22.2c-5.19-.43-10.13,.45-14.36,2.32-.09-.2-.19-.4-.31-.6-2.01-3.43-5.93-3.86-10.79-3.16l4.84,7.66c-2.38,2.04-4.27,4.5-5.5,7.26h0l-7.83,3.52c-1.11-.09-2.06,.79-2.06,1.9,.01,1.72,.11,4.08,.55,5.28,1.73,4.7,12.76,12.08,14.6,13.29,.04,.03,.08,.05,.11,.08,.05,.04,.1,.07,.15,.11l1.03,8.91c.12,1.04,1,1.83,2.05,1.83h3.42c1.05,0,1.93-.79,2.05-1.83l.54-4.65c2.34,.62,4.97,1.06,7.92,1.29,4.07,.32,7.99-.16,11.53-1.28l.54,4.64c.12,1.04,1,1.83,2.05,1.83h3.42c1.05,0,1.93-.79,2.05-1.83l1.41-9.95c3.77-3.38,6.23-7.83,6.65-12.88,.99-11.93-9.78-22.56-24.07-23.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.95,
    cy: 18.17,
    r: 8.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.75,18.86c-.17-.29-.4-.53-.68-.71-.28-.19-.59-.34-.93-.47-.29-.11-.58-.2-.86-.28v-2.14c.1,.02,.2,.05,.29,.08,.2,.08,.36,.18,.5,.31,.14,.13,.22,.28,.26,.46l1.5-.41c-.13-.39-.33-.72-.59-.99-.27-.27-.6-.47-.99-.61-.29-.1-.62-.16-.97-.18v-.84h-.77v.85c-.4,.04-.78,.1-1.1,.24-.44,.18-.79,.46-1.04,.82-.25,.36-.38,.8-.38,1.31,0,.41,.07,.75,.22,1.01,.15,.27,.35,.49,.6,.65s.54,.31,.85,.42c.28,.1,.56,.19,.85,.28v2.42c-.12-.02-.23-.05-.33-.1-.22-.09-.4-.22-.53-.39-.14-.17-.22-.36-.26-.59l-1.5,.42c.09,.42,.28,.79,.56,1.1,.29,.31,.65,.54,1.1,.7,.3,.11,.62,.17,.97,.2v.86h.77v-.84c.55-.03,1.02-.12,1.4-.31,.44-.22,.77-.52,.99-.9,.22-.38,.33-.8,.33-1.26,0-.44-.09-.8-.26-1.09Zm-3.37-1.78c-.22-.09-.4-.2-.54-.34-.14-.13-.2-.31-.2-.53,0-.2,.06-.38,.18-.53,.12-.15,.28-.27,.48-.35,.07-.03,.14-.04,.22-.06v1.85s-.09-.03-.13-.05Zm1.62,3.71c-.17,.15-.42,.23-.72,.27v-2.15c.08,.03,.17,.06,.25,.1,.26,.11,.46,.25,.61,.41,.14,.16,.22,.36,.22,.6,0,.3-.12,.56-.35,.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.77,27.63c4.92-3.11,13.29-1.91,16.95,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.43,40.86c0-1.66-1.34-3-3-3s-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCost);
export default __webpack_public_path__ + "static/media/project-cost.b21a1c84c5949ba4854bd479417ef762.svg";
export { ForwardRef as ReactComponent };